import { createTaskFilterFunction, RunbookFilterType } from './filters'
import { TaskListTask } from 'main/services/queries/types'

export const hasSuccessors = createTaskFilterFunction(
  'hs',
  (task: TaskListTask, filters: RunbookFilterType): boolean => {
    return filters.hs ? task.successor_ids.length > 0 : task.successor_ids.length === 0
  }
)
